<template>
  <div class="field__choice"
    role="radiogroup">
    <label v-for="opt in options"
      :key="opt[valueKey]"
      :class="['field__option', opt.tone && 'tone-' + opt.tone, { on: opt[valueKey] === modelValue }]">
      <input type="radio"
        :name="name || $attrs.id"
        :checked="opt[valueKey] === modelValue"
        :disabled="$attrs.disabled"
        @change="$emit('update:modelValue', opt[valueKey])">
      <i v-if="opt.icon"
        :class="opt.icon"
        aria-hidden="true" />{{ opt[labelKey] }}
    </label>
  </div>
</template>

<script>
// Two to four choices side by side, each a capsule; options may carry an `icon` and a `tone` (green, yellow, red).
export default {
  name: 'choice-input',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: [String, Number, Boolean, null], default: null },
    options: { type: Array, default: () => [] },
    labelKey: { type: String, default: 'name' },
    valueKey: { type: String, default: 'id' },
    name: { type: String, default: '' },
  },
}
</script>

<style lang="scss" src="./choice.scss"></style>
